import {
  MaintenanceSection,
  MaintenanceSectionContent,
  MaintenanceSectionHeader,
} from "../../components/layout/maintenance";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@/components/shadcn/button";
import { useEffect, useState } from "react";
import { WebhookSearch } from "@/types/domain";
import { getWebhooks } from "@/api/webhook";
import { WebhookList } from "@/components/specific/webhook/webhookList";

export const WebhookMaintenance = () => {
  const navigate = useNavigate();

  const [webhooks, setWebhooks] = useState<WebhookSearch[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchWebhooks = async () => {
    try {
      setIsLoading(true);
      setError(null);
      setWebhooks(await getWebhooks());
    } catch (err) {
      setError("Failed to load webhooks");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchWebhooks();
  }, []);

  return (
    <>
      <MaintenanceSection>
        {(isLoading || error || webhooks.length > 0) && (
          <MaintenanceSectionHeader
            title="Webhooks"
            subtitle="Configure webhooks to receive real-time notifications when records change in your account."
          >
            {!isLoading && (
              <Button
                variant={"outline"}
                size={"sm"}
                title="Create a new Webhook"
                onClick={() => navigate("/maintenance/webhook/create")}
              >
                {<FontAwesomeIcon icon={faPlus} />}
                {"Create Webhook"}
              </Button>
            )}
          </MaintenanceSectionHeader>
        )}
        <MaintenanceSectionContent>
          <WebhookList
            webhooks={webhooks}
            onWebhookDeleted={fetchWebhooks}
            isLoading={isLoading}
            error={error}
          />
        </MaintenanceSectionContent>
      </MaintenanceSection>
    </>
  );
};
